function DropwdownInput(props) {
    return (
            <select className="form-select form-select-lg mb-3"
            onChange={props.onChange}>
                {props.options.map((optionItem) => (
                    <option key={optionItem} value={optionItem}> {optionItem} </option>
                ))}
            </select>
    );
}
export default DropwdownInput;
